// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useBankUploadData } from '@client/banks/providers/bank-upload-provider';
import type { BankUploadSection } from '@client/banks/types/bank-upload';
import { useStepsData } from '@shared/ui-kit/hooks/use-steps';
import { useCallback, useMemo } from 'react';
import {
  BANK_UPLOAD_SECTION_TABS,
  type BankUploadDataSection,
  getListStepForDataSection,
  isBankUploadDataSection,
} from './bank-upload-section-tabs';

export const useBankUploadSectionTabs = () => {
  const { navigate, meta, current } = useStepsData();
  const { closeListEditor } = useBankUploadData();

  const currentSection = meta?.section as BankUploadSection | undefined;

  const activeTab = useMemo(() => {
    if (!isBankUploadDataSection(currentSection)) {
      return 'accounts';
    }

    return currentSection;
  }, [currentSection]);

  const onSelectSection = useCallback(
    (section: BankUploadDataSection) => {
      const listStep = getListStepForDataSection(section);

      if (current === listStep) {
        return;
      }

      closeListEditor();
      navigate(listStep);
    },
    [closeListEditor, current, navigate],
  );

  return {
    tabs: BANK_UPLOAD_SECTION_TABS,
    activeTab,
    onSelectSection,
  };
};
